import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Chat.css";
import { chatmessages, chats, profile } from "../../../components/Apis";
import axiosInstance from "../../../axiosConfig/instance";


const Chat = () => {
  const [showSidebar, setShowSidebar] = useState(false); // State to toggle sidebar on mobile
  const [message, setMessage] = useState(""); // State to manage the input message
  const chatBodyRef = useRef(null); // Reference to chat body
  const token = localStorage.getItem("token") || ""; // Get token from localStorage
  const [sideChats, setSideChats] = useState([])
  const [chatID, setChatID] = useState(1)
  
  const [chatName, setChatName] = useState()
  const [chatMessages, setChatMessages] = useState([])
  const [profilee, setProfile] = useState(null);
  const [profileID, setProfileID] = useState(`${profilee}`)
  const [chatReceiverId, setChatReceiverId] = useState("034eeda7-28b5-4b35-b264-438798036fa5")
  const [render, setRender] = useState(false)


  console.log("chatMessages", chatMessages)
  console.log("profilee owner Id", profilee)
  

// Fetch profile on mount
useEffect(() => {
  const fetchProfile = async () => {
    const profileData = await profile(); // or useGetProfile() if it's async
    console.log("profileData", profileData)
    setProfile(profileData?.id);
  };

  fetchProfile();
}, []);


  //render function
  const RenderFunction = ()=>{setRender(!render)}
  // Fake data for messages


  // Scroll to the bottom of the chat body when send a new messages 
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [chatmessages]);

  // Handle sending a message
  useEffect(() => {
  }, [render])
  const handleSendMessage = async () => {
    if (message.trim()) {
      const newMessage = {
        chat_id: chatID,
        sender_id: profileID,
        receiver_id: chatReceiverId,
        message: message,
      };
      setMessage([...message, newMessage]);
      setMessage(""); // Clear the input
      
      try {
        const response = await axiosInstance.post(`/v1/owners/send-owner-message`, newMessage, // FormData as the request body
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
          });
          RenderFunction(); 
          setChatName("Admin")
          console.log(response.data)
        return response.data.data
      } catch (error) {
        console.log(error);

        return error
      }
    }
  };

  // ----------------------------------Sidebar Chat ----------------------------------
  useEffect(() => {
    const fetchSideChats = async () => {
      try {
        const response = await chats()
        setSideChats(response);
        // console.log("chats kldfjsjfkk", response.data.data)
      } catch (error) {
        // console.error("Error fetching Bank Account:", error);
      }
    };
    if (token) fetchSideChats();
  }, [token,sideChats]);

  const handleChatID = (id, name) => {
    setChatID(id)
    setChatName(name)
  }

  // ---------------------------------- Chat Messages ----------------------------------
  useEffect(() => {

    const fetchChatMessages = async () => {
      try {
        const response = await chatmessages(chatID)
        setChatMessages(response);
        // console.log("chats kldfjsjfkk", response.data.data)
      } catch (error) {
        // console.error("Error fetching Bank Account:", error);
      }
    };
    if (token) fetchChatMessages();
  // ---------------------------------- Fetch chat in every second ----------------------------------

    const interval = setInterval(() => {
      fetchChatMessages();
    }, 1000); // Fetch every 1 second

    return () => clearInterval(interval); 

  }, [token, chatID, render]);
  // ---------------------------------- Profile Id ----------------------------------
  useEffect(() => {
    const fetchProfileId = async () => {
      try {
        const response = await profile()
        setProfileID(response.id);
        // console.log("chats kldfjsjfkk", response.data.data)
      } catch (error) {
        // console.error("Error fetching Bank Account:", error);
      }
    };
    if (token) fetchProfileId();
  }, [token, profileID]);
  // ---------------------------------- sender Id ----------------------------------
  useEffect(() => {
    if (Array.isArray(sideChats)) {
      sideChats.forEach((chat) => {
        if (chat.sender.id !== profileID) {
          setChatReceiverId(chat.sender.id)
        } else {
          setChatReceiverId(chat.receiver.id)
        }
      })
    }
  }, [token, sideChats]);

  return (
    <div className="chat-container" style={{height:"100vh", backgroundColor: "var(--seco-col)" }}>
      <div className="row flex justify-content-center" dir="ltr">
        {/* Sidebar Toggle Button for Mobile */}
        <button
          className="btn d-md-none m-2"
          style={{ backgroundColor: 'var(--pri-col)', color: 'white', border: 'none' }}
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Hide Chats" : "Show Chats"}
        </button>

        {/* Sidebar */}
        <div className={`col-md-3 p-3  ${showSidebar ? "d-block" : "d-none d-md-block"}`}>
          <ul className="list-unstyled p-3 rounded">
            <h4 style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>Messages</h4>
            {sideChats.map((chat) => (
              (chat.sender.id !== profileID) ? (
                <li className="mb-3" onClick={() => handleChatID(chat.chat_id, chat.sender.name)}>
                  <img
                    src="/assets/Ellipse.png"
                    alt="Kristian Weston"
                    className="rounded-circle"
                  />
                  <span className="ms-2">{chat.sender.name}</span>
                  <span className="ms-2" style={{color:"blue"}}>{chat.last_updated}</span>
                </li>
              ) : (
                <li className="mb-3" onClick={() => handleChatID(chat.chat_id, chat.receiver.name)}>
                  <img
                    src="/assets/Ellipse.png"
                    alt="Kristian Weston"
                    className="rounded-circle"
                  />
                  <span className="ms-2">{chat.receiver.name}</span>
                </li>
              )
            ))}


            {/* <li className="mb-3">
              <img
                src="/assets/Ellipse.png"
                alt="Kristian Weston"
                className="rounded-circle"
                width="40"
              />
              <span className="ms-2">Kristian Weston</span>
            </li>
            <li className="mb-3">
              <img
                src="/assets/Ellipse.png"
                alt="Esther Howard"
                className="rounded-circle"
                width="40"
              />
              <span className="ms-2 text-primary">Esther Howard ● Online</span>
            </li>
            <li className="mb-3">
              <img
                src="/assets/Ellipse.png"
                alt="Jane Cooper"
                className="rounded-circle"
                width="40"
              />
              <span className="ms-2">Jane Cooper</span>
            </li> */}
          </ul>
        </div>

        {/* Chat Area */}
        <div className="col-md-6 p-3">
          <div className="chat-box bg-white p-3 rounded d-flex flex-column" style={{ height: "calc(100vh - 2rem)" }}>
            <div className="chat-header">
              <h4 style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>{chatName ? chatName : "No Chat Selected"}</h4>
            </div>
            <div ref={chatBodyRef} className="flex-grow-1 overflow-auto">
              {chatMessages ? chatMessages.map((msg) => (
                <Message key={msg.id} message={msg} profileID={profileID} />
              )) : "No Messages Found"}
            </div>
            <div className="message-input-box mt-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type a message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                />
                <button
                  className="border-0 bg-transparent"
                  onClick={handleSendMessage}
                >
                  <img src="/assets/Vector.png" alt="send" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Message = ({ message, profileID }) => {
  return (
    <div className={`message mb-2 ${message.sender_id === profileID ? "text-end" : "text-start"}`}>
      <div
        className={`message-text p-2 rounded text-start ${message.sender_id === profileID ? "text-black" : "bg-light"
          }`}
        style={{ backgroundColor: "#DFEEF4" }}
      >
        <div style={{display:"flex",flexDirection:"column"}}>
          <p>{message.message}</p>
          <span style={{width:"100%",color:"gray",fontSize:"10px",textAlign:"end"}}>{message.timestamp}</span>
        </div>
        {/* <p>{message.message}<span style={{color:"gray"}}>{message.timestamp}</span></p> */}
        {/* <small className={`text-muted ${message.sender === "user" ? "text-black-50" : "text-muted"}`}>
          {message.time}
        </small> */}
      </div>
    </div>
  );
};

export default Chat;




// chat area

// <div className="col-md-6 p-3">
// <div ref={chatBodyRef} className="chat-box bg-white p-3 rounded">
//   <div className="chat-header">
//     <h4 style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>Esther Howard</h4>
//   </div>
//   {messages.map((msg) => (
//     <Message key={msg.id} message={msg} />
//   ))}

//   <div className="message-input-box mt-3 ">
//     <div className="input-group ">
//       <input
//         type="text"
//         className="form-control fixed-bottom"
//         placeholder="Type a message..."
//         value={message}
//         onChange={(e) => setMessage(e.target.value)}
//         onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
//       />
//       <button
//         className="border-0 bg-transparent"
//         onClick={handleSendMessage}
//       >
//         <img src="/assets/Vector.png" alt="send" />
//       </button>
//     </div>
//   </div>
// </div>
// </div>